import * as CL from '@design-system/component-library';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { dsClass } from '../../../common/constants/dsClasses.js';
import {
  costCenterAndReferenceMsg,
  costCenterMsg,
  costCenterToolTipMsg,
  notMandatoryMsg,
  referenceIdMsg,
  referenceToolTipMsg,
  t,
} from '../../../common/i18n/index.js';
import { CostCenter } from '../../../common/react-hook-form/fields/CostCenter.js';
import { Reference } from '../../../common/react-hook-form/fields/Reference.js';
import { GridColumn } from '../../BillingAccountDetails/components/GridColumn.js';
import type { Contact } from '../../../generated/api/contact.js';
import type { ContactOrPurposeOfUseFormValues } from '../ContactsOrPurposeOfUseUtils.js';

interface CostCenterAndEmployeeNumberProps {
  isCostCenterRequired?: boolean;
  contacts?: Contact[];
}

export const CostCenterAndEmployeeNumber = ({ isCostCenterRequired, contacts }: CostCenterAndEmployeeNumberProps) => {
  const {
    watch,
    resetField,
    formState: { isDirty },
  } = useFormContext<ContactOrPurposeOfUseFormValues>();
  const selectContact = watch('selectContact');
  const costCenter = watch('costCenter');
  const employeeNumber = watch('employeeNumber');

  // Sets new cost center and employee number from contact when contact changes
  useEffect(() => {
    const selectedContact = selectContact && contacts?.find(c => c.contactId === selectContact);
    if (selectedContact) {
      const newCostCenter = isDirty
        ? selectedContact.person?.costCenter || ''
        : costCenter || selectedContact.person?.costCenter || '';
      const newEmployeeNumber = isDirty
        ? selectedContact.person?.employeeNumber || ''
        : employeeNumber || selectedContact.person?.employeeNumber || '';
      resetField('costCenter', { defaultValue: newCostCenter });
      resetField('employeeNumber', { defaultValue: newEmployeeNumber });
    }
  }, [selectContact]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={dsClass.PADDING_TOP_2}>
      <h5 className={`${dsClass.MARGIN_BOTTOM_1} ${dsClass.MARGIN_TOP_3}`}>{t.JBEM(costCenterAndReferenceMsg)}</h5>
      <CL.Grid className={`of-contact-or-purpose-of-use__grid ${dsClass.PADDING_TOP_2}`}>
        <CL.GridRow className="of-contact-or-purpose-of-use__grid_column of-contact-or-purpose-of-use__cost_center_employee_number">
          <GridColumn>
            <CostCenter
              required={isCostCenterRequired}
              tooltip={t.UE8R(costCenterToolTipMsg)}
              label={`${t.L2OG(costCenterMsg)}${!isCostCenterRequired ? ' ' + t.NFRH(notMandatoryMsg) : ''}`}
            />
          </GridColumn>
          <GridColumn>
            <Reference
              label={`${t.CWR5(referenceIdMsg)} ${t.NFRH(notMandatoryMsg)}`}
              tooltip={t.HBBD(referenceToolTipMsg)}
            />
          </GridColumn>
        </CL.GridRow>
      </CL.Grid>
    </div>
  );
};
